import React from "react";

function Home() {
  return (
    <div className="home">
      <h2>Master new languages with dayê.</h2>
      <h1 className="title">dayê</h1>
    </div>
  );
}

export default Home;
